import cuotomerService from "@/apis/customer/index";
export function getHisPatientEnums() {
  return cuotomerService.hisPatientEnums().then((res) => {
    Object.keys(res).forEach((key) => {
      if (Array.isArray(res[key])) {
        res[`${key}_map`] = {};
        res[key].forEach((item) => {
          res[`${key}_map`][item.Value] = item.Text;
        });
      }
    });
    return res;
  });
}
